import React, { PureComponent } from 'react'
import { Menu, Icon } from 'semantic-ui-react'
import { connect } from 'react-redux'
import CollaboratorActions from 'Redux/CollaboratorRedux'
import SelectionActions from 'Redux/SelectionRedux'
import { path } from 'ramda'
import AddCollaborator from 'Components/AddCollaborator'
import ConfirmPopup from 'Components/ConfirmPopup'

import styles from './SideBarRightStyles.js'

class SideBarRight extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      documentTitle: '',
      deletingCollaboratorId: null
    }
  }

  componentDidMount () {
    this.requestCollaborators()
  }

  componentDidUpdate (prevProps) {
    if (this.props.match !== prevProps.match) {
      this.requestCollaborators()
    }
  }

  requestCollaborators = () => {
    const projectId = path(['params', 'projectId'], this.props.match)
    this.props.collaboratorsListRequest(projectId)
  }

  onDeleteStart = (collaboratorId) => () => {
    this.setState({deletingCollaboratorId: collaboratorId})
  }

  onDelete = (collaboratorId) => () => {
    const projectId = path(['params', 'projectId'], this.props.match)
    this.props.collaboratorsRemoveRequest(collaboratorId, projectId)
  }

  onCancelDelete = () => {
    this.setState({deletingCollaboratorId: null})
  }

  render () {
    const projectId = path(['params', 'projectId'], this.props.match)
    if (!projectId) return null
    return (
      <React.Fragment>
        <Menu.Item header className={styles.header}>
          Collaborators
        </Menu.Item>
        {this.props.userData.role !== 'collaborator' &&
          <Menu.Item className={styles.collaboratorSlab}>
            <AddCollaborator />
          </Menu.Item>
        }
        {this.props.collaborators.map(({id, name, email}) => {
          const collaboratorIdentity = name || email;
          return <Menu.Item key={id} className={styles.collaboratorSlab}>
            <span className={styles.collaboratorIdentity}
                  title={collaboratorIdentity}>
              {collaboratorIdentity}
            </span>
            {this.props.userData.role !== 'collaborator' &&
              <ConfirmPopup
                trigger={
                  <Icon name='minus'/>
                }
                attached='top'
                onConfirm={this.onDelete(id)}
              />
            }
          </Menu.Item>
        })}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  collaborators: state.collaborators.listData,
  activeProject: state.selections.activeProject
})

const mapDispatchToProps = (dispatch) => ({
  collaboratorsListRequest: (projectId) =>
    dispatch(CollaboratorActions.collaboratorsListRequest(projectId)),
  collaboratorsRemoveRequest: (collaboratorId, projectId) => {
    return dispatch(
      CollaboratorActions.collaboratorsRemoveRequest(collaboratorId, projectId)
    )
  },
  selectionsSetData: (key, value) =>
    dispatch(SelectionActions.selectionsSetData(key, value))
})

export default connect(mapStateToProps, mapDispatchToProps)(SideBarRight)



// WEBPACK FOOTER //
// ./src/Components/SideBarRight.js